var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.title,"right-text":_vm.rightText,"left-arrow":"","list":_vm.isList},on:{"click-left":_vm.onClickLeft,"click-right":_vm.toSearch}})}
var staticRenderFns = []

export { render, staticRenderFns }